import { BehaviorSubject } from 'rxjs';

export class AuthProperties {
  // Access token property for auth management
  static accessToken$ = new BehaviorSubject('');
  static mgmtAccessToken = '';
}
